import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useLocation, NavLink } from 'react-router-dom';
import { host, storage, inquiry } from 'src/models/urlEndpoints';
import DeserializeToObject from 'src/utilities/DeserializeToObject';
import { InquiryModel, InquiryDetails } from 'src/models/InquiryModel';
import { QuestionsAndAnswears } from 'src/models/ContainerModel';
import style from './Inquiry.module.scss';
import { priceWithFixedDiggits } from 'src/utilities/numbersFormatter';
import ISessionParams from 'src/interfaces/ISessionParams';
import userRoles from 'src/enums/userRoles';
import { useTranslation } from 'react-i18next';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function removeTrailingColon(str: string): string {
  return str.trim().endsWith(':') || str.trim().endsWith('.') ? str.trim().slice(0, -1) : str.trim();
}
function splitAndTranslate(str: string, t: any): string
{
  const divided = splitAtTwoCapitals(str);
  return `${t(divided[0])} ${divided.length > 1? divided[1]: ""}`;
}
function splitAtTwoCapitals(str: string): string[] {
  const match = str.match(/[A-Z]{2}/);
  if (match && match.index !== undefined) {
    return [str.slice(0, match.index).trim(), str.slice(match.index).trim()];
  }
  return [str.trim()];
}

function calculateHeight(ID: InquiryDetails): number {
  return 240 + (220 * ID.Wysokosc) / 605;
}
const questionsArray = [
  'QKolorRamy',
  'QKolorOkladziny',
  'Wariant konstrukcji',
  'Kieszenie transportowe',
  'Izolacja w dachu',
  'Sanitarne - Izolacja w dachu',
  'Izolacja w podlodze',
  'Sanitarne - Izolacja w podlodze',
  'Izolacja w scianach',
  'Sanitarne - Izolacja w panelach',
  'Uwagi dodatkowe',
];

interface IProps extends Partial<ISessionParams> {
  children?: React.ReactNode;
}
const Inquiry = (props: IProps) => {
  const { t, i18n } = useTranslation();
  let { docname, userid } = useParams<{ docname: string; userid: string }>();
  let query = useQuery();
  const [inquiryModel, setInquiryModel] = useState<InquiryModel | undefined>(undefined);
  const [visibleDetails, setVisibleDetails] = useState(false);

  const downloadInquiry = useCallback(async (docname, userid) => {
    // const urlAdress = query.get('url') || '';
    try {
      const resp = await fetch(`${host}/${inquiry(docname, userid)}`);
      const text = await resp.text();
      const inQuiryModel = JSON.parse(text);

      inQuiryModel.fullJson = JSON.parse(inQuiryModel.fullJson);
      inQuiryModel.jsonq = JSON.parse(inQuiryModel.jsonq);
      const transformedInquiry: InquiryModel = DeserializeToObject(new InquiryModel(), inQuiryModel);
      setInquiryModel(transformedInquiry);
      console.log(transformedInquiry);
    } catch (e) {
      console.log(e);
      console.error(e);
    }
  }, []);
  useEffect(() => {
    if (!docname || !userid) {
      return;
    }
    downloadInquiry(docname, userid);
  }, [docname, userid]);

  if (inquiryModel === null) return <p>nieprawidłowe dane</p>;
  if (!inquiryModel) return <p>wczytywanie</p>;
  return (
    <div className={style.main_container}>
      <header className={style.header_container}>
        <img width="200" src={`${window.location.origin}/nag.png`} alt="logo" />
        <span>
          {t('Estimate')}: <b>{inquiryModel.humanReadableCode}</b> {<br />}
          {t('project name')}: <b> {inquiryModel.projectName} </b>
        </span>
        <span>
          {inquiryModel.userName}
          {'\n'}
          {inquiryModel.fullJson.DaneOsob?.Firma}
          {'\n'}
          {inquiryModel.fullJson.DaneOsob && (
            <div className={style.personalData}>
              <h6>{t('first name')}: {inquiryModel.fullJson.DaneOsob?.Imie} {' '}
                / {t('last name')}: {inquiryModel.fullJson.DaneOsob?.Nazwisko} {' '}
                / {t('phone')}: {inquiryModel.fullJson.DaneOsob?.Telefon || '-'} {' '}
                / email: {inquiryModel.fullJson.DaneOsob?.Email || '-'}</h6>
            </div>
          )}
        </span>

      </header>
      <section className={style.section}>
        <article className={style.project_image_holder}>

          <div style={{display: "flex", flexDirection: "row", flex:1, justifyContent: "space-between"}}>
            <h1>{t('project')}</h1>
            <div style={{backgroundColor: "gray", display: "flex"}}>
              {props.children}
            </div>
          </div>
          {inquiryModel.links.split('|').map((value, index) => (
            <div key={value} className={style.project_image}>
              <p>{t('kondygnacja')} {index}</p>
              <img
                height={calculateHeight(inquiryModel.fullJson)}
                src={`${storage}${value}`}
                alt={`kondygnacja ${index}`}
              />
            </div>
          ))}
          <div></div>

        </article>
        <article className={style.tables}>
          <div>
            <h2>{t('Container options')}:</h2>
            <table className={style.tablesOptions}>
              {inquiryModel.jsonq.getQuestionsByArray(questionsArray).map((value, index) => (
                <tr key={value.QI}>
                  <td>{index + 1}</td>
                  <td>{t(removeTrailingColon(value.QT))}</td>
                  <td>{t(value.AT)}</td>
                </tr>
              ))}
            </table>
          </div>
          <div>
            <h2>{t('Opcje konteneru:')}</h2>
            <table className={style.tablesContainers}>
              <tr>
                <th>{t('nr')}</th>
                <th>{t('typ')}</th>
                <th>{t('kondygnacja')}</th>
                <th>{t('uwagi')}</th>
                <th>{t('Cena')}</th>
              </tr>
              {inquiryModel.fullJson.ListaKontenerow?.map((value, index) => (
                <tr key={Math.random().toString()}>
                  <td>{index + 1}</td>
                  <td>
                    {value.Nazwa} <br /> {value.FNazwa}
                  </td>
                  <td>{value.Kondygnacja + 1}</td>
                  <td>
                    {value.ListaModyfikacji?.reduce((accu, next) => {
                      if (next.TypZmiany.substring(0, 14) === 'Dodatkowy opis') {
                        return `${accu} ${next.TypZmiany} : ${next.KosztZmiany} ${(<br />)}`;
                      }
                      return accu;
                    }, '')}
                  </td>
                  <td>{value?.getCenaZeZmianami(inquiryModel.currencyUsed as number, inquiryModel.plnMultiplayer)}</td>
                </tr>
              ))}
              <tr>
                <td></td>
                <td colSpan={2}>{t('Obróbki')}</td>
                <td>
                  {inquiryModel.fullJson.CenaObrobek === inquiryModel.fullJson.ObrobkiDane?.CenaZeZmianami
                    ? ''
                    : 'ceny wymagają sprawdzenia'}
                </td>
                <td>{inquiryModel.fullJson.ObrobkiDane?.getCenaZeZmianami(inquiryModel.currencyUsed as number, inquiryModel.plnMultiplayer)}</td>
              </tr>
              <tr>
                <td></td>
                <td colSpan={2}>{t('Elementy dodatkowe')}</td>
                <td className={style.additional_description}>
                  <span>
                    {inquiryModel.fullJson.ElementyDodatkowe?.ListaModyfikacji?.map((elem) => {
                      return (
                        <>
                          {<br />} {splitAndTranslate(elem.TypZmiany.split('*')[0], t)}, {t('ilość')}: {elem.Ilosc}
                        </>
                      );
                    })}
                  </span>
                </td>
                <td>{inquiryModel.fullJson.ElementyDodatkowe?.getCenaZeZmianami(inquiryModel.currencyUsed as number, inquiryModel.plnMultiplayer)}</td>
              </tr>
              <tr>
                <th className={style.additional_description} colSpan={3}>
                  {t('Razem')}
                </th>
                <th className={`${style.additional_description} ${style.description_highlight}`} colSpan={2}>
                  {priceWithFixedDiggits(inquiryModel.fullJson.LacznaCena, inquiryModel.currencyUsed as number, inquiryModel.plnMultiplayer, 0, 0)}
                </th>
              </tr>
            </table>
            <p className={style.safety_info}>
              <span>
                {t(removeTrailingColon('Ceny netto, „LOCO Ogorzelice / Dobrzyńska / Kobiałka.'))} <br /> {t(removeTrailingColon('Podana wycena jest wersją roboczą, do potwierdzenia przez Dział Wycen Modular System.'))}
              </span>
            </p>
          </div>
        </article>
        <article className={style.save_link}>
          <p>
            <span>
              <b>{t('Adres zapisanego projektu')}</b>
            </span>
          </p>
          <p>{inquiryModel.fullJson.LinkZapisu}</p>
          <NavLink to={`/model/model?url=${inquiryModel.fullJson.LinkZapisu}`}>
            {t('Szczegóły projektu')} <br /></NavLink>
          <NavLink to={`/project?adress=${inquiryModel.fullJson.LinkZapisu}`}>
            {t('Wczytaj projekt')}  <br /></NavLink>
          {props.backendUser && props.backendUser?.idAAD && props.backendUser?.role >= userRoles.seller && (
            <NavLink to={`/project?adress=${inquiryModel.fullJson.LinkZapisu}&override=${inquiryModel.userAAD}`}>
              {t('Wczytaj w imieniu klienta')}</NavLink>
          )}
        </article>
      </section>
      <footer>
        <div className={style.footer}>
          <div>
            <div />
          </div>
          <p>
            <span>
              MODULAR SYSTEM SP. Z O.O. <br />
              UL. BIELSKA 19 <br />
              09-412 OGORZELICE <br />
              NIP: 7123301642 <br />
            </span>
          </p>
        </div>
        <h5 data-phone={inquiryModel.fullJson.DaneOsob?.Telefon} data-email={inquiryModel.fullJson.DaneOsob?.Email}>
          {inquiryModel.fullJson.DaneOsob?.Firma}
        </h5>
        <button onClick={(e) => setVisibleDetails(!visibleDetails)} id="displayer" type="button">
          {t('Elementy')}
        </button>
        <p className={style.additional_elements} style={{ display: visibleDetails ? 'block' : 'none' }}>
          {inquiryModel.fullJson.ObrobkiDane?.ListaModyfikacji?.map((elem) => (
            <span>
              {elem.TypZmiany.split('*')[0]} x {elem.Ilosc} <br />
            </span>
          ))}
          {inquiryModel.fullJson.ElementyDodatkowe?.ListaModyfikacji?.map((elem) => (
            <span>
              {elem.TypZmiany.split('*')[0]} x {elem.Ilosc} <br />
            </span>
          ))}
          <a
            href={`${window.location.origin}/model/view?url=${inquiryModel.fullJson.LinkZapisu}`}
            target="_blank"
          >{`${window.location.origin}/model/view?url=${inquiryModel.fullJson.LinkZapisu}`}</a>
        </p>
      </footer>
    </div>
  );
};
export default Inquiry;
